module.exports = __webpack_public_path__ + "static/media/IMG_1128.0dc57fbd.jpg";